export const ENTRY = 'createuser';
export const BASE_PATH = '/createuser/details';
export const PAGE_NAME = 'createuser';
export const PAGE_TYPE = 'CreateAccount';
export const ANALYTICS_NAME = 'CreateAccount';
export const TITLE = 'Create Account | Join Zocdoc now';
export const ROLLUP_BUCKET = 'Utility';
